




































































































































































































  import Vue from "vue";
  import DetailQuestions from "./components/detail-questions.vue";
  import ComparisonView from "./views/comparisonView.vue";
  import {IAccountDetails, IAssessment} from "./store/main.interfaces";
  import {Component} from "vue-property-decorator";
  import {makeEmptyAssessmentObject} from "./store/assessment.util";
  import assessments from "./store/modules/assessments";
  import user, {userHasPrivilege, userHasRole} from "./store/modules/user";
  import AdministrationView from "./views/accountAdministrationView.vue";
  import SettingsView from "./views/settingsView.vue";
  import api from "./store/api";
  import {getRouteByName, ROUTE_NAMES} from "@/router";

  @Component({
  components: {
    DetailQuestions,
    ComparisonView,
    AdministrationView,
    SettingsView
  }
})
export default class App extends Vue {
  dialog: boolean = false;
  savedDialog: boolean = false;
  deleteDialog: boolean = false;
  editDialog: boolean = false;
  deletionErrorDialog: boolean = false;
  createAccountDialog: boolean = false;
  resolveDialog: boolean = false;
  noAssessmentError: boolean = false;
  id: string = "0";
  item: IAssessment = makeEmptyAssessmentObject();
  drawer: boolean = false;
  assessmentToResolve!: IAssessment;
  editableAssessment: IAssessment | null = null;

  navBarItems() {
    return [
      {
        icon: "mdi-compare",
        text: this.$t("app.navigation.names.compareAssessments"),
        link: getRouteByName(ROUTE_NAMES.ASSESSMENTS),
        restriction: "READ_ORG_ASSESSMENTS"
      },
      {
        icon: "mdi-account-plus",
        text: this.$t("app.navigation.names.manageAccounts"),
        link: getRouteByName(ROUTE_NAMES.ADMINISTRATION),
        restriction: "WRITE_USERS"
      },
      {
        icon: "mdi-cogs",
        text: this.$t("app.navigation.names.settings"),
        link: getRouteByName(ROUTE_NAMES.SETTINGS),
        restriction: "READ_ORG_ASSESSMENTS"
      },
      {
        icon: "mdi-compare",
        text: this.$t("app.navigation.names.organization"),
        link: getRouteByName(ROUTE_NAMES.ORGANIZATION),
        restriction: "MANAGE_OWN_ORGANIZATION"
      },
      {
        icon: "mdi-compare",
        text: this.$t("app.navigation.names.processes"),
        link: getRouteByName(ROUTE_NAMES.ORCHESTRATOR_RELEASES),
        condition: () => this.isOrchestratorAvailable
      }
    ];
  }

  logout() {
    user.logout();
  }

  resetDrawerAndProperties() {
    this.drawer = false;
    assessments.refreshAssessments();
  }

  async onLoadUserProcesses(userAccount: IAccountDetails) {
    this.$router.push("assessments/" + userAccount.username);
  }

  get isOrchestratorAvailable(): boolean {
    return !!user.organization && !!user.organization.isOrchestratorAvailable;
  }

  async deleteAssessment(item: IAssessment) {
    const deleteResult = await assessments.deleteAssessment(item.id as string);
    if (deleteResult === false) {
      this.deletionErrorDialog = true;
    }
  }
  onAssessmentSaved(item: IAssessment) {
    this.savedDialog = true;
    this.item = item;
    this.closeEditDialog();
  }

  resolveAssessmentDialogText() {
    if (this.assessmentToResolve) {
      if (this.assessmentToResolve.implemented === true) {
        return this.$t("dialogs.implementation.shallBeMarkedAsNotImplemented");
      } else {
        return this.$t("dialogs.implementation.shallBeMarkedAsImplemented");
      }
    }
  }

  async resolveAssessment() {
    if (this.assessmentToResolve.implemented === undefined) {
      this.assessmentToResolve.implemented = false;
    }
    this.assessmentToResolve.implemented = !this.assessmentToResolve
      .implemented;
    const createdOrUpdatedAssessment = await assessments.createOrUpdateAssessment(
      this.assessmentToResolve
    );
    this.resolveDialog = false;
  }
  closeEditDialog() {
    this.editDialog = false;
    this.editableAssessment = null;
  }
  getAssessmentList() {
    return this.allAssessments;
  }
  get allAssessments() {
    return assessments.allAssessments;
  }
  get isLoggedIn() {
    return user.isLoggedIn;
  }
  get userName() {
    return user.userData != null ? user.userData.username : "";
  }
  get userRoles() {
    return user.userData != null ? user.userData.roles : [];
  }
  get userPrivileges() {
    return user.userData != null ? user.userData.privileges : [];
  }
  hasSpecificRole(restriction: string): boolean {
    return userHasRole(restriction);
  }
  hasSpecificPrivilege(restriction: string): boolean {
    return userHasPrivilege(restriction);
  }
  mounted() {
    window.setInterval(async () => {
      const sessionStatus = await api.isSessionActive();
      if (sessionStatus === false && user.isLoggedIn) {
        this.logout();
      }
    }, 30000);
  }
}
